var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m4 11h2v5h-2zm.556-7.112c.245-.49.894-.888 1.45-.888h11.987c.556 0 1.206.398 1.45.888l1.557 3.112h-18zm-1.556 3.112h18v1h-18zm15 4h2v5h-2zm-15-3c.14 1.128 1.094 2 2.25 2s2.11-.872 2.25-2zm4.5 0c.14 1.128 1.094 2 2.25 2s2.11-.872 2.25-2zm4.5 0c.14 1.128 1.094 2 2.25 2s2.11-.872 2.25-2zm4.5 0c.14 1.128 1.094 2 2.25 2s2.11-.872 2.25-2zm-12.5 8h16v2.995c.0013.5303-.208 1.0393-.5819 1.4153s-.8818.5881-1.4121.5897h-12.012c-.26267-.0004-.52269-.0526-.76515-.1536-.24246-.1011-.46261-.2489-.64784-.4352-.18522-.1862-.33189-.4072-.43158-.6502-.0997-.243-.15048-.5033-.14943-.766z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.eb0ab8aea5bb2c21a7a6009974429774.svg";
export { ForwardRef as ReactComponent };